import { ReactElement, ReactNode } from 'react'

import { Container, StyledCollapse, Title } from './styles'

interface AdVisualPerformanceSectionProps {
  title: string
  children: ReactNode
  onExpand?: () => void
}

export const AdVisualPerformanceSection = ({
  title,
  children,
  onExpand,
}: AdVisualPerformanceSectionProps): ReactElement => {
  const collapseProps = onExpand
    ? {
        activeKey: [],
        onChange: onExpand,
      }
    : {
        defaultActiveKey: [],
      }

  return (
    <Container>
      <StyledCollapse
        {...collapseProps}
        items={[
          {
            key: '1',
            label: <Title>{title}</Title>,
            children,
          },
        ]}
      />
    </Container>
  )
}
